import React, { useState } from "react";

// components
import CardContactsTable from "components/Cards/CardContactsTable.js";
import CardContactDetail from "components/Cards/CardContactDetail.js";

export default function Leads() {
  const [selectedContact, setSelectedContact] = useState(null);

  const handleViewContact = (contact) => {
    setSelectedContact(contact);
  };

  const handleCloseDetail = () => {
    setSelectedContact(null);
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        {/* Main Contacts Table */}
        <div className="w-full mb-12 px-4">
          <CardContactsTable
            color="light"
            onViewContact={handleViewContact}
          />
        </div>
      </div>

      {/* Contact Detail Modal */}
      <CardContactDetail
        contact={selectedContact}
        isOpen={!!selectedContact}
        onClose={handleCloseDetail}
      />
    </>
  );
}
